module.exports = __webpack_public_path__ + "static/media/infoicon.da9e5388.svg";